<vex-ged-layout [canAddDoc]="true" [loading]="loading" [addDocumentTitle]="addDocumentTitle" [listTitle]="listTitle">
  <base-data-table
    [dataSource]="dataSource"
    [displayedColumns]="displayedColumns"
    [feisColumns]="feisColumns"
    [showPaginator]="false"
    (onDeleteItem)="openDelete($event)"
    (onDownloadItem)="downloadDocument($event.DWDOCID)"
    [showSort]="false"
  ></base-data-table>
  <div dragFormZone [permissionBlock]="[ENUM_PERMISSIONS.UPDATE_CONTRACT]">
    <div fxLayout="column" *ngIf="!loading">
      <vex-drop-zone [files]="files"></vex-drop-zone>
      <button
        mat-raised-button
        color="primary"
        class="mt-4"
        fxFlexAlign="end"
        (click)="validForm()"
        [loading]="loadingSave"
        [disabled]="form.invalid || files.length === 0"
      >
        ENREGISTRER
      </button>
    </div>
  </div>
</vex-ged-layout>
